/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Team_Manager_Remove_User_From_Group_FailedInputs */

const en_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error removing user from group. ${i?.error}`)
};

const fr_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors du retrait de l’utilisateur du groupe. ${i?.error}`)
};

const de_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Entfernen des Benutzers aus der Gruppe. ${i?.error}`)
};

const it_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante la rimozione dell'utente dal gruppo. ${i?.error}`)
};

const ru_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка при удалении пользователя из группы. ${i?.error}`)
};

const es_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al eliminar usuario del grupo. ${i?.error}`)
};

const zh_cn2_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`从组中移除用户时出错。${i?.error}`)
};

const ja_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`グループからユーザーを削除中にエラーが発生しました。${i?.error}`)
};

const hi_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`समूह से उपयोगकर्ता को हटाने में त्रुटि। ${i?.error}`)
};

const pt_pt2_team_manager_remove_user_from_group_failed = /** @type {(inputs: Team_Manager_Remove_User_From_Group_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao remover o usuário do grupo. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error removing user from group. {error}" |
*
* @param {Team_Manager_Remove_User_From_Group_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_remove_user_from_group_failed = /** @type {((inputs: Team_Manager_Remove_User_From_Group_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Remove_User_From_Group_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "de") return de_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "it") return it_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "ru") return ru_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "es") return es_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "ja") return ja_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "hi") return hi_team_manager_remove_user_from_group_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_remove_user_from_group_failed(inputs)
	return en_team_manager_remove_user_from_group_failed(inputs)
});